var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHabitsIcon = function SvgHabitsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_30",
    "data-name": "Group 30",
    width: 29.137,
    height: 36.546,
    viewBox: "0 0 29.137 36.546",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M692.385,506.156a5.862,5.862,0,0,1,2.893-1.258,3.035,3.035,0,0,0-5.786,0,5.862,5.862,0,0,1,2.893,1.258",
    transform: "translate(-682.227 -502.781)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M708.323,520.23a3.032,3.032,0,0,1-5.315-1.9,3.029,3.029,0,0,0-2.456,1.257,2.9,2.9,0,0,0-2.746-2.015c-.908,0-1.34.4-2.167,1.032v-1.729a2.3,2.3,0,0,1-1.909-1.079l-1.3-2.043-1.057,2.056c-.4.635-1.524,1.006-1.524,1.065v10.277l-2-2.312a3.184,3.184,0,0,0-4.376-.579,3.123,3.123,0,0,0-.641,4.317l8.056,10.747h14.9l2.542-2.6a11.544,11.544,0,0,0,3.041-7.391v-6.069a3.04,3.04,0,0,0-3.041-3.035",
    transform: "translate(-682.227 -502.781)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M688.971,512.453c-2.489,0-3.6-1.524-3.6-3.035s1.115-3.034,3.6-3.034c2.264,0,3.972,2.505,4.044,2.611l.284.423-.284.423c-.072.107-1.78,2.612-4.044,2.612m0-4.552c-1.306,0-2.086.567-2.086,1.517s.78,1.518,2.086,1.518a1.7,1.7,0,1,0,0-3.035",
    transform: "translate(-682.227 -502.781)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M695.8,512.454c-2.264,0-3.972-2.5-4.044-2.612l-.284-.423.284-.423c.072-.107,1.78-2.612,4.044-2.612,2.489,0,3.6,1.524,3.6,3.035s-1.115,3.035-3.6,3.035m-2.456-3.032a3.8,3.8,0,0,0,2.456,1.514c1.306,0,2.086-.567,2.086-1.517s-.78-1.517-2.086-1.517a3.778,3.778,0,0,0-2.456,1.52",
    transform: "translate(-682.227 -502.781)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M695.562,515.369a.759.759,0,0,1-.648-.363l-2.534-4.142L689.8,515.01a.759.759,0,1,1-1.29-.8l3.225-5.192a.778.778,0,0,1,.647-.358.759.759,0,0,1,.645.362l3.176,5.192a.757.757,0,0,1-.251,1.043.75.75,0,0,1-.395.112",
    transform: "translate(-682.227 -502.781)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHabitsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/habits-icon.ab528f6a.svg";
export { ForwardRef as ReactComponent };